import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import { postApiData, postApiFormData } from "../../helpers/AxiosInstance";
import Button from "../../shared/Button";
import MultiImageField from "../../shared/MultiImageField";
import TextAreaField from "../../shared/TextAreaField";
import TextField from "../../shared/TextField";
import { ISeo } from "../../types/interface";
import { createSEOValidation } from "../../utils/validationSchema";
import { useState } from "react";

const Seoform = ({ id, setIsOpen, refetch }) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleAddSEO = async (values: any, setError: any) => {
    setIsLoading(true);
    const url = APIS.META_TAG;
    const formData = new FormData();
    formData.append("keywords", values?.keywords);
    formData.append("description", values?.description);
    formData.append("title", values?.title);
    formData.append("page_id", id);
    values?.image ? formData.append("image", values?.image) : null;
    try {
      const res = await postApiFormData({ url, formData, setError });
      if (res?.status === 201) {
        setIsOpen(false);
        refetch();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const { control, handleSubmit, setError } = useForm<ISeo>({
    resolver: yupResolver(createSEOValidation),
    defaultValues: async () => {
      let data: any = await refetch();
      return {
        ...data?.data?.[0],
      };
    },
  });

  return (
    <>
      <form onSubmit={handleSubmit((data) => handleAddSEO(data, setError))}>
        <div className={tw`grid grid-cols-1 gap-y-2 mt-4 min-w-[500px]`}>
          <TextField label="Title" name="title" control={control} />
          <TextAreaField
            label="Keywords"
            name="keywords"
            control={control}
            row={4}
          />
          <TextAreaField
            label="Description"
            name="description"
            control={control}
            row={4}
          />
          <MultiImageField control={control} name="image" label="Image" />
        </div>
        <div className={tw`w-24 ml-auto`}>
          <Button label="Add" isLoading={isLoading} />
        </div>
      </form>
    </>
  );
};

export default Seoform;
